import { render, staticRenderFns } from "./dictionarySettings.vue?vue&type=template&id=292b25a2&"
import script from "./dictionarySettings.vue?vue&type=script&lang=js&"
export * from "./dictionarySettings.vue?vue&type=script&lang=js&"
import style0 from "./dictionarySettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports